import { Injectable } from '@angular/core';
import { API_point_imports_excel } from '@core/api/paths';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PointImportProviderService {
  constructor(private apiService: ApiService) {}

  importPointsFromExcel(workspaceId: string, payload: FormData): Observable<void> {
    const url = API_point_imports_excel(workspaceId);

    return this.apiService.postWithFormData<void>(url, payload);
  }
}
